
import React from 'react';
import { Bell, BellOff } from 'lucide-react';
import { 
  Card, 
  CardContent, 
  CardDescription,
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";

interface ReminderSettingsProps {
  remindersEnabled: boolean;
  setRemindersEnabled: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReminderSettings: React.FC<ReminderSettingsProps> = ({ 
  remindersEnabled, 
  setRemindersEnabled 
}) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Appointment Reminders</CardTitle>
            <CardDescription>Configure automated reminders for patients</CardDescription>
          </div>
          <Switch 
            checked={remindersEnabled} 
            onCheckedChange={setRemindersEnabled}
          />
        </div>
      </CardHeader>
      
      <CardContent>
        <div className="space-y-4">
          <div className={`space-y-4 ${!remindersEnabled ? 'opacity-50' : ''}`}>
            <p className="text-sm text-muted-foreground">
              When enabled, patients will automatically receive reminder notifications at the following intervals:
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="border rounded-md p-3 flex items-center">
                <Bell className="h-4 w-4 text-primary mr-2" />
                <span className="text-sm">24 hours before appointment</span>
              </div>
              
              <div className="border rounded-md p-3 flex items-center">
                <Bell className="h-4 w-4 text-primary mr-2" />
                <span className="text-sm">2 hours before appointment</span>
              </div>
              
              <div className="border rounded-md p-3 flex items-center">
                <Bell className="h-4 w-4 text-primary mr-2" />
                <span className="text-sm">15 minutes before appointment</span>
              </div>
            </div>
          </div>
          
          {!remindersEnabled && (
            <div className="p-3 border rounded-md bg-yellow-50 flex items-center">
              <BellOff className="h-4 w-4 text-yellow-500 mr-2" />
              <span className="text-sm text-yellow-700">
                Reminders are currently disabled. Patients will not receive automated notifications about upcoming appointments.
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ReminderSettings;
